angular.module('jv.candidate.details.evaluations.view.controller', [])
    .controller('CandEvalDetails',['$scope', '$timeout', '$routeParams', 'candidates', '$location', '$rootScope', '$filter', 'evalSvc',
        function($scope, $timeout, $routeParams, candidates, $location, $rootScope, $filter, evalSvc){
        $scope.flags.loading = true;
        $scope.flags.showEmptyFormText = false;
        var modalType;
        var modalState;
        $scope.modal = $rootScope.modal || {};
        $scope.showAiTranscript = false;
        $scope.showItxSummaryTab = false;
        $scope.showAiTranscriptGrid = false;
        $scope.itxSummaryActiveTab = 'summary'; // Initialize default tab for Transcript and Summary Tab Component
        $scope.toggleGridAiSummary = function() {
            $scope.showItxSummaryTab = !$scope.showItxSummaryTab;
        };
        $timeout(function () {
                let showEl = document.getElementById('msg-show');
                let hideEl = document.getElementById('msg-hide');
                if (showEl && hideEl) {
                    $scope.transcriptMessages = {
                        show: showEl.textContent.trim(),
                        hide: hideEl.textContent.trim()
                    };
                    $scope.$applyAsync();
                }
            }, 2000);

        $scope.scrollDistance = 100;
        $scope.scrollToLeft = function () {
            let el = document.getElementById('scrollableTable');
            if (el) {
                el.scrollBy({ left: -$scope.scrollDistance, behavior: 'smooth' });
                $timeout(function () {
                    $scope.updatePagingState(el);
                }, 300);
            }
        };

        $scope.scrollToRight = function () {
            let el = document.getElementById('scrollableTable');
            if (el) {
                el.scrollBy({ left: $scope.scrollDistance, behavior: 'smooth' });
                $timeout(function () {
                    $scope.updatePagingState(el);
                }, 300);
            }
        };

        $scope.updatePagingState = function (el) {
        $scope.$applyAsync(function () {
            $scope.evaluations.paging.prev = el.scrollLeft > 0;
            $scope.evaluations.paging.next = el.scrollLeft + el.clientWidth < el.scrollWidth;
        });
        };

        var addPendingEvaluations = function(evaluation){
            angular.forEach($scope.evaluations.interviewList_map.list, function(val){
                if(val.id === $routeParams.stateId){
                    evaluation.pendingEvals = val.list['_PENDING'] || [];
                }
            });
        };

        var fillGridQuestion = function(questions, completedInterviews){
            for(var i=0; i <questions.length; i++){
                if($rootScope.size(questions[i].response) !== completedInterviews.length){
                    for(var j=0; j<completedInterviews.length; j++){
                        var present = false;
                        angular.forEach(questions[i].response, function(ans){  // eslint-disable-line no-loop-func
                            if(ans.EId === completedInterviews[j].EId){
                                present = true;
                            }
                        });
                        if(!present){
                            questions[i].response.push({
                                EId: completedInterviews[j].EId,
                                answer: '',
                                submitted: completedInterviews[j].submitted
                            });
                        }
                    }
                }
            }
        };

        var addResponseGrid = function(questionArr, objQues, objRes, index, isHeader){
            var added;
            var obj = {};
            if(index){
                added = false;
                if(questionArr.length >= index){
                    for(var i=0; i<questionArr.length; i++){
                        if(questionArr[i].question === objQues && i === index){
                            questionArr[i].response.push(objRes);
                            added = true;
                        }
                    }

                    if(!added){
                        obj.response = [];
                        obj.question = objQues;
                        obj.isHeader = isHeader;
                        obj.response.push(objRes);
                        questionArr.splice(index, 0, obj);
                    }
                }else{
                    for(var k=0; k<questionArr.length; k++){
                        if(questionArr[k].question === objQues){
                            questionArr[k].response.push(objRes);
                            added = true;
                        }
                    }

                    if(!added){
                        obj = {};
                        obj.response = [];
                        obj.isHeader = isHeader;
                        obj.question = objQues;
                        obj.response.push(objRes);
                        questionArr.push(obj);
                    }
                }
            }else{
                added = false;
                var isAlredyThere = false;
                for(var m=0; m<questionArr.length; m++){
                    if(questionArr[m].question === objQues){
                        for(var j=0; j<questionArr[m].response.length; j++){
                            if(questionArr[m].response[j].EId === objRes.EId){
                                isAlredyThere = true;
                            }
                        }
                        if(!isAlredyThere){
                            questionArr[m].response.push(objRes);
                            added = true;
                        }else{
                            continue;
                        }
                    }
                }
                if(!added){
                    var response = [];
                    response.push(objRes);
                    questionArr.push({
                        question: objQues,
                        response: response
                    });
                }
            }
        };

        var processGridMode = function(interview){
            var gridView = {
                head:[],
                body:{}
            };

            var questionsSummary = [];
            var questionsInterview = [];
            var completedInterviews = [];
            var question, response;

            for( var i=0; i<interview.model.interviews.length; i++){
                if(interview.model.interviews[i].completed){
                    var headData = {
                        firstName: interview.model.interviews[i].user.firstName,
                        lastName: interview.model.interviews[i].user.lastName,
                        submitted: interview.model.interviews[i].submitted,
                        EId: interview.model.interviews[i].user.EId,
                        interviewEId: interview.model.interviews[i].EId,
                        hasRequestMoreInfo: interview.model.interviews[i].hasRequestMoreInfo,
                        canEdit: interview.model.interviews[i].canEdit
                    };

                    gridView.head.push(headData);

                    completedInterviews.push({
                        EId: interview.model.interviews[i].EId,
                        submitted: interview.model.interviews[i].submitted || ''
                    });

                    if(interview.model.interviews[i].details && interview.model.interviews[i].details.summary){
                        if(interview.model.interviews[i].details.summary.rating_asArray && interview.model.interviews[i].details.summary.rating_asArray.length > 0){
                            question = $scope.i18n['CANDIDATE_SUMMARY'];
                            response = {
                                EId: interview.model.interviews[i].EId,
                                answer:'',
                                submitted: 0
                            };
                            addResponseGrid(questionsSummary, question, response);

                            for(var k=0; k<interview.model.interviews[i].details.summary.rating_asArray.length; k++){
                                question = interview.model.interviews[i].details.summary.rating_asArray[k]._title;
                                response = {
                                    EId: interview.model.interviews[i].EId,
                                    answer: interview.model.interviews[i].details.summary.rating_asArray[k]._rating || '',
                                    comment: interview.model.interviews[i].details.summary.rating_asArray[k]._comments || '',
                                    submitted: interview.model.interviews[i].submitted || '',
                                    hasRating: interview.model.interviews[i].details.summary.rating_asArray[k]._hasrating
                                };
                                addResponseGrid(questionsSummary, question, response);
                            }
                        }
                    }

                    if(interview.model.interviews[i].details && interview.model.interviews[i].details.interview){
                        if(interview.model.interviews[i].details.interview.item_asArray && interview.model.interviews[i].details.interview.item_asArray.length > 0){
                            question = $scope.i18n['EVALUATIONS'];
                            response = {
                                EId: interview.model.interviews[i].EId,
                                answer:'',
                                submitted: 0
                            };
                            addResponseGrid(questionsInterview, question, response);

                            for(var l=0; l<interview.model.interviews[i].details.interview.item_asArray.length; l++){
                                question = interview.model.interviews[i].details.interview.item_asArray[l]._description;
                                response = {
                                    EId: interview.model.interviews[i].EId,
                                    answer: interview.model.interviews[i].details.interview.item_asArray[l]._rating ? $scope.evaluations.grades[interview.model.interviews[i].details.interview.item_asArray[l]._rating] : '',
                                    comment: interview.model.interviews[i].details.interview.item_asArray[l]._comments || '',
                                    submitted: interview.model.interviews[i].submitted || '',
                                    hasRating: interview.model.interviews[i].details.interview.item_asArray[l]._hasrating
                                };
                                addResponseGrid(questionsInterview, question, response);
                            }
                        }

                        if(interview.model.interviews[i].details.interview.header_asArray){
                            for(var j=0; j<interview.model.interviews[i].details.interview.header_asArray.length; j++){
                                question = interview.model.interviews[i].details.interview.header_asArray[j]._description;
                                response = {
                                    EId: interview.model.interviews[i].EId,
                                    answer:'',
                                    submitted: interview.model.interviews[i].submitted || ''
                                };
                                addResponseGrid(questionsInterview, question, response, parseInt(interview.model.interviews[i].details.interview.header_asArray[j]._index)+1+j, true);
                            }
                        }
                    }
                }
            }

            fillGridQuestion(questionsSummary, completedInterviews);
            fillGridQuestion(questionsInterview, completedInterviews);

            $scope.evaluations.questionsSummary = questionsSummary;
            $scope.evaluations.questionsInterview = questionsInterview;
            $scope.evaluations.gridViewData = gridView;

            if($scope.evaluations.gridViewData.head.length > 3){
                $scope.evaluations.paging = {
                    prev: false,
                    next: true
                };
            }
        };

        var initFunctions = function(){
            $scope.evaluations.grades = [
                $scope.i18n.EXCELLENT,
                $scope.i18n.GOOD,
                $scope.i18n.FAIR,
                $scope.i18n.POOR,
                $scope.i18n.NA
            ];

            var selectedInterview = $scope.evaluations.interviewList_map.stateIds[$routeParams.stateId];
            if(selectedInterview){
                selectedInterview.viewMode = $routeParams.view || 'list';

                addPendingEvaluations(selectedInterview);
                evalSvc.convertEvalToJson(selectedInterview);

                for(var i in selectedInterview.model.interviews){
                    for(var j in selectedInterview.model.interviewActions[selectedInterview.model.interviews[i].EId]){
                        if(selectedInterview.model.interviewActions[selectedInterview.model.interviews[i].EId][j].title === 'requestDetails'){
                            selectedInterview.model.interviews[i].hasRequestMoreInfo = true;
                        }
                        if(selectedInterview.model.interviewActions[selectedInterview.model.interviews[i].EId][j].title === 'editEvaluation'){
                            selectedInterview.model.interviews[i].canEdit = true;
                        }
                        if(selectedInterview.model.interviewActions[selectedInterview.model.interviews[i].EId][j].title === 'forwardEvaluations'){
                            selectedInterview.canForwardEvaluation = true;
                        }
                    }
                }

                if(selectedInterview.viewMode === 'grid'){
                    processGridMode(selectedInterview);
                }

                for(var l in selectedInterview.model.interviews){
                    if(selectedInterview.model.interviews[l].completed){
                        selectedInterview.hasCompletedEval = true;
                        break;
                    }
                }

                $scope.evaluations.selectedInterview = angular.copy(selectedInterview);
                $scope.evaluations.loggedInuser = window.jvUser;
            }
        };

        if(!$scope.evaluations || !$routeParams.stateId || ($rootScope.evaluations && $rootScope.evaluations.fastRead)){
            $rootScope.miniHeader = {
                show: true,
                back: 'workflow/'+$routeParams.applicationId
            };

            var fastRead = false;
            if($rootScope.evaluations){
                if($rootScope.evaluations.fastRead){
                    fastRead = true;
                    $rootScope.evaluations.fastRead = false;
                    $rootScope.evaluations.refresh = true;
                }
            }

            candidates.getEvaluations($routeParams.applicationId, $routeParams.stateId, $routeParams.interviewId, fastRead, function(res){
                $rootScope.evaluations = $rootScope.evaluations || {};
                $rootScope.evaluations.interviewList = [];
                $rootScope.evaluations.interviewList.push(res.evaluationInfo);
                $rootScope.evaluations.interviewList_map = evalSvc.transformInterviewEvaluations($rootScope.evaluations.interviewList);
                $scope.flags.loading = false;
                initFunctions();
            });
        }else{
            initFunctions();
            $scope.flags.loading = false;
        }

        $scope.showReminderLink = function(evalList){
            var ret = false;

            if(evalList){
                for(var i=0; i<evalList.length; i++){
                    for(var j=0; j<evalList[i].actions.length; j++){
                        if(evalList[i].actions[j].title === 'sendEvaluationReminder'){
                            ret = true;
                            break;
                        }
                    }
                    if(ret){
                        break;
                    }
                }
            }
            return ret;
        };
        
        $scope.modal.cancel = function(){
            $rootScope.modal.form.to = null;
            $rootScope.modal.show = false;
        };

        $scope.modal.ok = function() {
            var data = angular.copy($rootScope.modal.form);
            var toList = [];

            if (data.to && angular.isArray(data.to)){
                angular.forEach(data.to, function(value){
                    toList.push({eid: value.EId});
                });
            }else if(data.to_label){
                angular.forEach(data.toObj, function(value){
                    toList.push({eid: value.EId});
                });
            }

            data.to = toList;
            if(data.to.length === 0){
                return;
            }
            angular.forEach(data.cc, function(cc){
                data.to.push({eid: cc.EId});
            });
            delete data.cc;
            delete data.toObj;
            delete data.to_label;
            delete data.hideCC;
            data.from = { eid: window.jvUser };

            $rootScope.flags.loading = true;
            if(modalType === 'MORE_INFO'){
                candidates.postEvalRequestMoreDetails($routeParams.applicationId, $routeParams.stateId, modalState.interview.EId, modalState.interview.user.EId, data, function(res){
                    $rootScope.flags.loading = false;
                    if(res.msgInfo === 200){
                        $scope.showMsg('DETAILS_REQUESTED');
                        $rootScope.modal.form.to = null;
                        $rootScope.modal.show = false;
                    }
                });
            }else if(modalType === 'FORWARD'){
                candidates.postEvalForwardTmpl($routeParams.applicationId, $routeParams.stateId, data, function(res){
                    $rootScope.flags.loading = false;
                    if(res.msgInfo === 200){
                        $scope.showMsg('EVALUATION_SENT');
                        $rootScope.modal.form.to = null;
                        $rootScope.modal.show = false;
                    }
                });
            }else if(modalType === 'SEND_REMINDER'){
                candidates.postEvaluationReminder($routeParams.applicationId, $routeParams.stateId, data, function(res){
                    $rootScope.flags.loading = false;
                    if(res.msgInfo === 200){
                        $scope.showMsg('REMINDER_SENT');
                        $rootScope.modal.form.to = null;
                        $rootScope.modal.show = false;
                    }
                });
            }
        };

        $scope.evalAction = function(type, options){
            $rootScope.flags.loading = true;
            $rootScope.modal.show = false;
            $rootScope.evalArr = [];
            modalType = type;
            modalState = angular.copy(options);
            if(type === 'MORE_INFO'){
                candidates.getEvalRequestMoreDetails($routeParams.applicationId, $routeParams.stateId, modalState.interview.EId, modalState.interview.user.EId, function(response){
                    $rootScope.flags.loading = false;
                    $rootScope.modal.title = i18n.REQUEST_MORE_INFO;
                    $rootScope.modal.form = response.evaluationRequestMoreDetails.model.evaluationFormRequestMoreDetails;
                    angular.forEach(response.evaluationRequestMoreDetails.model.evaluationFormRequestMoreDetails.to, function(value){
                        $rootScope.evalArr.push(value.EId);
                    });

                    $rootScope.modal.form.to = $rootScope.evalArr;
                    $rootScope.modal.show = true;
                    $rootScope.modal.form.entityId = modalState.interview.EId;
                }, function(){
                    $rootScope.flags.loading = false;
                });
            }else if(type === 'FORWARD'){
                candidates.getEvalForwardTmpl($routeParams.applicationId, $routeParams.stateId, function(response){
                    $rootScope.flags.loading = false;
                    $rootScope.modal.title = i18n.FORWARD_EVALUATION;
                    $rootScope.modal.form = response.forwardEvaluation.model.forwardEvaluationMessage;
                    angular.forEach(response.forwardEvaluation.model.forwardEvaluationMessage.to, function(value){
                        $rootScope.evalArr.push(value.EId);
                    });

                    $rootScope.modal.form.to = $rootScope.evalArr;
                    $rootScope.modal.show = true;

                    if(modalState.list){
                        var evalList= angular.copy(modalState.list);
                        evalList = $filter('orderBy')(evalList, 'submitted', true);

                        for(var i=0; i<evalList.length; i++){
                            if(evalList[i].completed){
                                $rootScope.modal.form.entityId = evalList[i].EId;
                                break;
                            }
                        }
                    }

                }, function(){
                    $rootScope.flags.loading = false;
                });

            }else if(type === 'SEND_REMINDER'){
                candidates.getEvaluationReminderTempl($routeParams.applicationId, $routeParams.stateId, function(response){
                    $rootScope.flags.loading = false;
                    $rootScope.modal.title = i18n.SEND_REMINDER;
                    $rootScope.modal.form = response.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage;
                    $rootScope.modal.form.hideCC = true;
                    $rootScope.modal.form.to_label = true;
                    $rootScope.modal.form.toObj = angular.copy(response.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage.to);

                    angular.forEach(response.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage.to, function(value){
                        $rootScope.evalArr.push(value.fullName);
                    });
                    $rootScope.modal.form.to = $rootScope.evalArr.join(', ');
                    $rootScope.modal.show = true;

                    if(modalState.list){
                        var evalList=[];
                        angular.forEach(modalState.list, function(evaluation){
                            evalList.push(evaluation.evaluationId);
                        });
                        $rootScope.modal.form.entityIdList = evalList;
                    }

                }, function(){
                    $rootScope.flags.loading = false;
                });
            }else if (type === 'PRINT'){
                $scope.evaluations.printPreview = $scope.evaluations.selectedInterview;
                $scope.evaluations.printPreview.hasAllInterviewStates = false;
                window.$windowScope = $scope;
                window.$windowScope.isPrintEvaluation = true;
                window.open('details/evaluations/printPreviewEvalPopout.html','_blank','width=1200, height=600, scrollbars=yes');
                $rootScope.flags.loading = false;
            }else{
                $rootScope.flags.loading = false;
            }
        };
    }
]);